/**
 * @description 轉換分割年月日
 */
export const divideDate = (strDate: string) => {
  const year = strDate.substring(0, 4);
  const month = strDate.substring(4, 6).replace(/^0/, '');
  const day = strDate.substring(6, 8).replace(/^0/, '');
  return {
    y: year,
    m: month,
    d: day
  };
};
